import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserQueueV1Response } from './get-user-queue-v1-response';
import { getUserQueueV1ResponseSchema } from './get-user-queue-v1-response';

export async function getUserQueueV1Api(
  userId: string,
): Promise<IValidatedResponse<IGetUserQueueV1Response>> {
  return getRequest<IGetUserQueueV1Response>({
    path: `/sys/users/v1/${userId}/queue`,
    schema: getUserQueueV1ResponseSchema,
  });
}
